// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/evaluation/v1/service.proto (package chalk.evaluation.v1, syntax proto3)
/* eslint-disable */

import { EvaluationService } from "./service_pb";

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.CreateEvaluationSuite
 */
export const createEvaluationSuite = EvaluationService.method.createEvaluationSuite;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.UpdateEvaluationSuite
 */
export const updateEvaluationSuite = EvaluationService.method.updateEvaluationSuite;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.ListEvaluationSuites
 */
export const listEvaluationSuites = EvaluationService.method.listEvaluationSuites;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.CreateEvaluation
 */
export const createEvaluation = EvaluationService.method.createEvaluation;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.GetEvaluation
 */
export const getEvaluation = EvaluationService.method.getEvaluation;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.ListEvaluations
 */
export const listEvaluations = EvaluationService.method.listEvaluations;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.ArchiveEvaluation
 */
export const archiveEvaluation = EvaluationService.method.archiveEvaluation;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.UnarchiveEvaluation
 */
export const unarchiveEvaluation = EvaluationService.method.unarchiveEvaluation;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.CreateEvaluationRun
 */
export const createEvaluationRun = EvaluationService.method.createEvaluationRun;

/**
 * Score a finished run's rows again, with its own evaluation's task and
 * scorers or with another evaluation's over the same dataset revision. Only
 * what changed since that run is called: the task's outputs are read back out
 * of the rescored run when the evaluation names the same task, and a scorer's
 * values are copied from it when the run had the same scorer over the same
 * inputs, except on the rows that scorer failed on.
 *
 * @generated from rpc chalk.evaluation.v1.EvaluationService.RescoreEvaluationRun
 */
export const rescoreEvaluationRun = EvaluationService.method.rescoreEvaluationRun;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.GetEvaluationRun
 */
export const getEvaluationRun = EvaluationService.method.getEvaluationRun;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.ListEvaluationRuns
 */
export const listEvaluationRuns = EvaluationService.method.listEvaluationRuns;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.SetEvaluationRunBaseline
 */
export const setEvaluationRunBaseline = EvaluationService.method.setEvaluationRunBaseline;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.MoveEvaluationRun
 */
export const moveEvaluationRun = EvaluationService.method.moveEvaluationRun;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.ArchiveEvaluationRun
 */
export const archiveEvaluationRun = EvaluationService.method.archiveEvaluationRun;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.CreateOnlineEvaluator
 */
export const createOnlineEvaluator = EvaluationService.method.createOnlineEvaluator;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.GetOnlineEvaluator
 */
export const getOnlineEvaluator = EvaluationService.method.getOnlineEvaluator;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.ListOnlineEvaluators
 */
export const listOnlineEvaluators = EvaluationService.method.listOnlineEvaluators;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.UpdateOnlineEvaluator
 */
export const updateOnlineEvaluator = EvaluationService.method.updateOnlineEvaluator;

/**
 * @generated from rpc chalk.evaluation.v1.EvaluationService.DeleteOnlineEvaluator
 */
export const deleteOnlineEvaluator = EvaluationService.method.deleteOnlineEvaluator;
